import React from "react";
import ButtonAtm from "../../../../atomic/Button/Button";
import {CircularProgress, Backdrop, Snackbar} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import { OFFER_SEND_MAIL } from "../../../../../constants/api.constants";
import axios from "axios";
import { getAppLang, getProperty } from "../../../../../utils";
import Grow from "@material-ui/core/Grow";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#d71f26',
        height: '120vh'
    },
}))

function GrowTransition(props) {
    return <Grow {...props} />;
  }

const SendMail = (props) => {

    const classes = useStyles();
    const { t } = useTranslation();
    const offerId = props.id;
    const [loadingSpinner, setLoadingSpinner] = React.useState(false);
    const [openErrorMessage, setOpenErrorMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [openSuccessMessage, setOpenSuccessMessage] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState("");

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenErrorMessage(false);
      };
    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenSuccessMessage(false);
      };

    const handleSendMail = () => {
        setLoadingSpinner(true);
        setSuccessMessage("");
        setErrorMessage("");

        const params = {
            params: {
                property_id: getProperty(),
                offer_id: offerId
            }
        }
        axios.post(OFFER_SEND_MAIL, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            setTimeout(() => {
                setLoadingSpinner(false);
                setOpenSuccessMessage(true);
                setSuccessMessage(t('enw-notification-mail_sent_successfully'));
            }, 1000);
        }).catch(function (error) {
            console.log(error);
            setTimeout(() => {
                setLoadingSpinner(false);
                setOpenErrorMessage(true);
                setErrorMessage(t('enw-notification-mail_sent_error'))
            }, 1000);
            setSuccessMessage("");
            setOpenSuccessMessage(false);
        });
    }

    return (
        <>
            <ButtonAtm
                onClick={handleSendMail}
                className={"offer-list-button"} startIcon={<i className="fas fa-envelope" />}
            />
            {
                loadingSpinner &&
                <Backdrop className={classes.backdrop} open>
                    <CircularProgress className='circularProgress-mail' style={{color:"#d71f26", zIndex: "99"}} />
                </Backdrop>
            }
            {
                openErrorMessage &&
                <Snackbar open={openErrorMessage} autoHideDuration={4000} onClose={handleClose} TransitionComponent={GrowTransition}>
                    <Alert onClose={handleClose} severity="error">{errorMessage}</Alert>
                </Snackbar>
            }
            {
                openSuccessMessage &&
                <Snackbar open={openSuccessMessage} autoHideDuration={4000} onClose={handleCloseSuccess} TransitionComponent={GrowTransition}>
                    <Alert onClose={handleCloseSuccess} severity="success">{successMessage}</Alert>
                </Snackbar>
            }
        </>
    );
}

export default SendMail